import './ShowMoreTypeLabel.scss';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { getSonarObjectTypeAndSourceLabelPlural } from '@sonar-software/sonar-ts-lib';
import React from 'react';
export const ShowMoreTypeLabel = ({ allowShowMore, label, onClick, sonarObjectType }) => React.createElement("div", { className: 'data-dictionary-label', key: sonarObjectType },
    React.createElement("span", null, sonarObjectType ? getSonarObjectTypeAndSourceLabelPlural(sonarObjectType) : label),
    allowShowMore &&
        React.createElement("span", { className: 'show-more-link', onClick: () => onClick(sonarObjectType || label) }, COPY_GENERIC.SHOW_MORE));
